import { styled } from '@mui/material';

import { Box, Button, Modal, Typography } from '@app-velocity/ui';

import { useI18n } from '@app-velocity/i18n';

const StyledDescription = styled(Box)({
  textAlign: 'left',
});

const StyledTitle = styled(Typography)(({ theme }) => ({
  fontSize: 18,
  marginBottom: theme.spacing(2),
}));

const StyledText = styled(Typography)({
  color: 'var(--text-text-secondary-color)',
});

export const NewPluginUIVersionModalContent = () => {
  const { t } = useI18n();

  const reloadPluginUI = () => {
    window.location.reload();
  };

  return (
    <Modal data-testid="new-plugin-ui-version-modal">
      <Modal.Content>
        <StyledDescription>
          <StyledTitle variant="header" component="h2">
            {t('config:new_plugin_ui_version_title')}
          </StyledTitle>
          <StyledText variant="body2">
            {t('config:new_plugin_ui_version_text')}
          </StyledText>
        </StyledDescription>
        <Button variant="contained" color="primary" onClick={reloadPluginUI}>
          {t('config:actions.refresh')}
        </Button>
      </Modal.Content>
    </Modal>
  );
};
